export const construyeTuCaminoResultados = [
    {
        'num':'1',
        'proyecto':'Programa Construye Tu Camino del tramo: Acceso a la Localidad de Acuimantla, en el Municipio de Tepehuacán de Guerrero',
        'municipio':'Tepehuacán de Guerrero',
        'localidad':'Acuimantla',
        'inversion':'7875818.66',
    },
    {
        'num':'2',
        'proyecto':'Programa Construye Tu Camino en la Localidad de Pepeyoca de Cabrera, en el Municipio de Huautla',
        'municipio':'Huautla',
        'localidad':'Pepeyoca de Cabrera',
        'inversion':'6873441.74',
    },
    {
        'num':'3',
        'proyecto':'Programa Construye Tu Camino en la Localidad de Chicavasco, Camino Río Lerma, en el Municipio de Actopan',
        'municipio':'Actopan',
        'localidad':'Chicavasco',
        'inversion':'7016638.44',
    },
    {
        'num':'4',
        'proyecto':'Programa Construye Tu Camino del Acceso Principal a la Comunidad de El Apartadero, en el Municipio de Huichapan',
        'municipio':'Huichapan',
        'localidad':'El Apartadero',
        'inversion':'7088236.79',
    },
    {
        'num':'5',
        'proyecto':'Programa Construye Tu Camino en la Localidad de La Pechuga, tramo: Lagunita-La Pechuga, en el Municipio de Ixmiquilpan',
        'municipio':'Ixmiquilpan',
        'localidad':'La Pechuga',
        'inversion':'7088236.79',
    },
    {
        'num':'6',
        'proyecto':'Programa Construye Tu Camino en la Localidad de Plomosas, tramo: Plomosas-Benito Juárez, en el Municipio de Actopan',
        'municipio':'Actopan',
        'localidad':'Plomosas',
        'inversion':'7016638.44',
    },
    {
        'num':'7',
        'proyecto':'Programa Construye Tu Camino del tramo: Juntas Chicas-Río Beltrán, en el Municipio de Huehuetla',
        'municipio':'Huehuetla',
        'localidad':'Río Beltrán',
        'inversion':'7159835.15',
    },
    {
        'num':'8',
        'proyecto':'Programa Construye Tu Camino del tramo: Zapote Arriba-Santa Rosa Tetlama, en el Municipio de San Felipe Orizatlán',
        'municipio':'San Felipe Orizatlán',
        'localidad':'Zapote Arriba',
        'inversion':'7875818.66',
    },
    {
        'num':'9',
        'proyecto':'Programa Construye Tu Camino del tramo: Camino a la Campana de Tutotepec-Medio Monte, en el Municipio de San Bartolo Tutotepec',
        'municipio':'San Bartolo Tutotepec',
        'localidad':'Tutotepec',
        'inversion':'7159835.15',
    },
    {
        'num':'10',
        'proyecto':'Programa Construye Tu Camino en la Localidad de Cerro Colorado en el Municipio de Zimapán',
        'municipio':'Zimapán',
        'localidad':'Cerro Colorado',
        'inversion':'7088236.79',
    },
    {
        'num':'11',
        'proyecto':'Programa Construye Tu Camino del tramo: Acceso a la Localidad de Mecapala en el Municipio de Xochicoatlán',
        'municipio':'Xochicoatlán',
        'localidad':'Mecapala',
        'inversion':'7088236.79',
    },
    {
        'num':'12',
        'proyecto':'Programa Construye Tu Camino, Acceso a la Localidad de Los Reyes Tepezalá en el Municipio de Huasca de Ocampo',
        'municipio':'Huasca de Ocampo',
        'localidad':'Los Reyes Tepezalá',
        'inversion':'6801843.39',
    },
    {
        'num':'13',
        'proyecto':'Programa Construye Tu Camino del tramo: Acceso a la Localidad de Xuchiatipa en el Municipio de Tlahuiltepa',
        'municipio':'Tlahuiltepa',
        'localidad':'Xuchiatipa',
        'inversion':'7875818.66',
    },
    {
        'num':'14',
        'proyecto':'Programa Construye Tu Camino en la Localidad de Tlaxco, tramo: Tlaxco-Huayateno, en el Municipio de Metztitlán',
        'municipio':'Metztitlán',
        'localidad':'Tlaxco',
        'inversion':'7088236.79',
    },
    {
        'num':'15',
        'proyecto':'Programa Construye Tu Camino del Acceso a la Comunidad de Tepeyica, en el Municipio de Eloxochitlán',
        'municipio':'Eloxochitlán',
        'localidad':'Tepeyica',
        'inversion':'14264980.27',
    },
    {
        'num':'16',
        'proyecto':'Programa Construye Tu Camino del  tramo: La Pimienta-Talol, en el Municipio de Tlanchinol',
        'municipio':'Tlanchinol',
        'localidad':'La Pimienta',
        'inversion':'7159835.15',
    },
    {
        'num':'17',
        'proyecto':'Programa Construye Tu Camino del  tramo: San Pedro Huazalingo-Pilcuatla, en el Municipio de Tlanchinol',
        'municipio':'Tlanchinol',
        'localidad':'Pilcuatla',
        'inversion':'7875818.66',
    },
]